const p = "adyen-pe-typography";
export {
  p as DEFAULT_TYPOGRAPHY_CLASSNAME
};
